import { NotificationList } from "../../services/notifications/notifications-interface";
import { actionTypes } from "./notifications.actions";

export interface INoticationListState {
    notificationsLists: NotificationList;
};

const initialState : INoticationListState = {
  notificationsLists: {
    totalNotifications: 0,
    totalUnreadNotifications: 0,
    notifications: [],
    messages: "",
    success: false,
  },
};

export const noticationListReducer = (
  state: INoticationListState = initialState,
  action: { type: string, payload: any },
)=>{
  switch (action.type) {
  case actionTypes.SET_NOTIFICATION_LIST:
    return {
      ...state,
      notificationsLists: action.payload,
    };
  default: {
    return state;
  }
  }
};
